import { __assign } from "tslib";
import { connect } from 'react-redux';
import { compose } from 'redux';
import Rows from '../../../components/handoff/layout/Rows';
import onlyIf from '../../../hocs/onlyIf';
import { getIsRowOverlayOn, getRowConfig, } from '../../../selectors/layoutOverlay';
function mapStateToProps(state) {
    return __assign(__assign({}, getRowConfig(state)), { isOverlayOn: getIsRowOverlayOn(state) });
}
var isOverlayOn = function (props) { return props.isOverlayOn; };
export default compose(connect(mapStateToProps), onlyIf(isOverlayOn))(Rows);
